import React from "react"; // This is actually used. It's just not detected by the linter
import { PixelRatio, Platform, StyleSheet, View } from "react-native";
import variables from "../../styles/variables";
import { APP_ENV } from "../../client";

export type GapSize = keyof (typeof variables)["spacing"];
type Props = { vertical?: boolean; size?: GapSize; style?: any };

const isNative = Platform.OS !== "web";
const isIntegration = APP_ENV === "integration";
const pixelRatio = PixelRatio.get();

const Gap: React.FC<Props> = ({ vertical, size = "small", style }) => (
  <View
    style={[
      styles.gap,
      vertical
        ? {
            height: variables["spacing"][size],

            // isNative && isIntegration
            //   ? Math.floor(variables["spacing"][size] * pixelRatio) /
            //     pixelRatio
            //   : variables["spacing"][size],
          }
        : {
            width: variables["spacing"][size],

            // isNative && isIntegration
            //   ? Math.floor(variables["spacing"][size] * pixelRatio) /
            //     pixelRatio
            //   : variables["spacing"][size],
          },
      style,
    ]}
  />
);
const styles = StyleSheet.create({
  gap: { backgroundColor: "transparent" },
});

export default Gap;
